import { FC } from "react";
import S from "./index.module.scss";
import { CultureType } from "@/views/culture/constants/cultures";
import Image from "next/image";
import { useTranslations } from "next-intl";
import clsx from "clsx";

interface ICultureBlock {
  block: CultureType
}

const CultureBlock: FC<ICultureBlock> = ({block}) => {
  const t = useTranslations("culture");

  return (
    <div className={S.blockWrapper}>
      <Image src={`/images/culture/cultures/${block.image}.png`} alt={block.title} width={800} height={900} className={S.image} />
      <div className={clsx(S.textBlock, { [S["textBlock--reverse"]]: block.reverse })}>
        <h3 className={S.title}>{t(block.title)}</h3>
        <p className={S.description}>{t(block.description)}</p>
      </div>
    </div>
  )
};

export default CultureBlock;